<template>
    <vx-table-row>
        <vx-table-row-title>
            <vx-badge color="slate" size="xs" class="font-mono" data-test="campaign-id">
                {{ props.modelValue.campaign_id }}
            </vx-badge>
        </vx-table-row-title>

        <vx-table-row-item>
            <template v-slot:label> Source: </template>
            <span data-test="source">{{ sourceLabels[props.modelValue.source] }}</span>
        </vx-table-row-item>

        <vx-table-row-item data-test="brand">
            <template v-slot:label> Brand: </template>
            <kiosk-tcr-brand-cell
                v-if="props.modelValue.brand_id"
                :brandId="props.modelValue.brand_id"
                :displayName="props.modelValue.brand_display_name"
                :verified="props.modelValue.brand_verified"
                :vettingScore="props.modelValue.brand_vetting_score"
                :entityType="props.modelValue.brand_entity_type"
                :vettingClass="props.modelValue.brand_vetting_class"
                :vettingStatus="props.modelValue.brand_vetting_status"
            ></kiosk-tcr-brand-cell>
            <span v-else>—</span>
        </vx-table-row-item>

        <vx-table-row-item>
            <template v-slot:label> Use Case: </template>
            <span data-test="usecase">{{
                props.modelValue.usecase ? useCaseLabel(props.modelValue.usecase) : '—'
            }}</span>
        </vx-table-row-item>

        <vx-table-row-item>
            <template v-slot:label> Status: </template>
            <span data-test="status">{{
                props.modelValue.status ? campaignStatusLabels[props.modelValue.status] : '—'
            }}</span>
        </vx-table-row-item>

        <vx-table-row-item>
            <template v-slot:label> Class: </template>
            <vx-popover
                v-if="props.modelValue.att_message_class"
                hover
                :arrow="true"
                placement="top"
                data-test="message-class"
            >
                {{ messageClassLabel(props.modelValue.att_message_class) }}
                <template v-slot:content>
                    <div class="text-xs max-w-[240px]">
                        {{ messageClassDetail(props.modelValue.att_message_class) }}
                    </div>
                </template>
            </vx-popover>
            <span v-else>—</span>
        </vx-table-row-item>

        <vx-table-row-item data-test="phone-numbers-count">
            <template v-slot:label> Numbers: </template>
            {{ props.modelValue.phone_numbers_count }}
        </vx-table-row-item>

        <vx-table-row-item data-test="synced-at">
            <template v-slot:label> Synced: </template>
            <vx-popover hover :arrow="true" placement="top" :key="syncedAtKey">
                {{ fromNow(props.modelValue.synced_at) }}
                <template v-slot:content>
                    {{ shortDateTime(props.modelValue.synced_at) }}
                </template>
            </vx-popover>
        </vx-table-row-item>
    </vx-table-row>
</template>

<script lang="ts" setup>
import { VxBadge, VxPopover, VxTableRow, VxTableRowItem, VxTableRowTitle } from '@voxie/frontend-components';
import { useInterval } from '@vueuse/core';
import KioskTcrBrandCell from '~/components/kiosk/kiosk-ten-dlc/list/KioskTcrBrandCell.vue';
import {
    campaignStatusLabels,
    messageClassDetail,
    messageClassLabel,
    sourceLabels,
    useCaseLabel,
} from '~/components/kiosk/kiosk-ten-dlc/tenDlcLabels';
import type { TcrCampaign } from '~/services/adminTenDlcClient.types';
import { fromNow, shortDateTime } from '~/utils/date';

const props = defineProps<{
    modelValue: TcrCampaign;
}>();

const syncedAtKey = useInterval(60000);
</script>
